import React from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonTable = () => {
  const features = [
    {
      category: 'Book Creation',
      items: [
        { name: 'Books per month', free: '0', starter: '1', professional: '4', business: '10', enterprise: 'Unlimited' },
        { name: 'AI Agents 1-3 (Research, Voice, Outline)', free: true, starter: true, professional: true, business: true, enterprise: true },
        { name: 'AI Agents 4-11 (Writing & Publishing)', free: false, starter: true, professional: true, business: true, enterprise: true }
      ]
    },
    {
      category: 'Features',
      items: [
        { name: 'Writing voice capture', free: true, starter: true, professional: true, business: true, enterprise: true },
        { name: 'Topic research', free: true, starter: true, professional: true, business: true, enterprise: true },
        { name: 'Outline creation', free: true, starter: true, professional: true, business: true, enterprise: true },
        { name: 'AI manuscript writing', free: false, starter: true, professional: true, business: true, enterprise: true },
        { name: 'Cover design generation', free: false, starter: true, professional: true, business: true, enterprise: true },
        { name: 'KDP metadata creation', free: false, starter: true, professional: true, business: true, enterprise: true }
      ]
    },
    {
      category: 'Support & Community',
      items: [
        { name: 'Authorpreneur Community access', free: false, starter: true, professional: true, business: true, enterprise: true },
        { name: 'Email support', free: false, starter: 'Standard', professional: 'Priority', business: '24h', enterprise: 'Dedicated' },
        { name: 'Strategy calls', free: false, starter: false, professional: 'Monthly', business: 'Weekly', enterprise: 'Custom' }
      ]
    }
  ];

  const renderValue = (value) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="Check" size={20} color="var(--color-success)" />
      ) : (
        <Icon name="X" size={20} color="var(--color-muted-foreground)" />
      );
    }
    return <span className="text-sm text-foreground font-medium">{value}</span>;
  };

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-muted/50">
              <th className="px-6 py-4 text-left text-sm font-heading font-semibold text-foreground">
                Features
              </th>
              <th className="px-6 py-4 text-center text-sm font-heading font-semibold text-foreground">
                Free
              </th>
              <th className="px-6 py-4 text-center text-sm font-heading font-semibold text-foreground">
                Starter
              </th>
              <th className="px-6 py-4 text-center text-sm font-heading font-semibold text-secondary bg-secondary/5">
                Professional
              </th>
              <th className="px-6 py-4 text-center text-sm font-heading font-semibold text-foreground">
                Business
              </th>
              <th className="px-6 py-4 text-center text-sm font-heading font-semibold text-foreground">
                Enterprise
              </th>
            </tr>
          </thead>
          <tbody>
            {features?.map((category, categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                <tr className="border-t-2 border-border">
                  <td colSpan={6} className="px-6 py-3 bg-muted/20">
                    <span className="text-sm font-heading font-semibold text-foreground">
                      {category?.category}
                    </span>
                  </td>
                </tr>
                {category?.items?.map((item, itemIndex) => (
                  <tr key={itemIndex} className="border-t border-border hover:bg-muted/10">
                    <td className="px-6 py-4 text-sm text-muted-foreground">
                      {item?.name}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {renderValue(item?.free)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {renderValue(item?.starter)}
                    </td>
                    <td className="px-6 py-4 text-center bg-secondary/5">
                      {renderValue(item?.professional)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {renderValue(item?.business)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {renderValue(item?.enterprise)}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComparisonTable;